import React from 'react';
import { ICON } from 'resources/constants';

import {
  Wrapper,
  Icon,
  Name,
  Activities,
  Co2Label,
  HeaderHashtag,
  HeaderName,
  HeaderActivities,
  HeaderScore,
} from './elements';

type Props = {
  readonly className?: string;
  readonly nameText: string;
  readonly activitiesText: string;
  readonly labelText: string;
  readonly isSmall?: boolean;
};

function LBHead8(props: Props): React.ReactElement {
  return (
    <Wrapper className={props.className} as={'thead'}>
      <tr>
        <HeaderHashtag scope={'col'}>
          <Icon icon={ICON.hashtag} />
        </HeaderHashtag>
        <HeaderName scope={'col'} isSmall={props.isSmall}>
          <Name>{props.nameText}</Name>
        </HeaderName>
        {!props.isSmall && (
          <HeaderActivities scope={'col'}>
            <Activities>{props.activitiesText}</Activities>
          </HeaderActivities>
        )}
        <HeaderScore scope={'col'} isSmall={props.isSmall}>
          <Co2Label>{props.labelText}</Co2Label>
        </HeaderScore>
      </tr>
    </Wrapper>
  );
}

export default LBHead8;
